import { render, staticRenderFns } from "./SponsorAdmin.vue?vue&type=template&id=130338e6&scoped=true"
import script from "./SponsorAdmin.vue?vue&type=script&lang=js"
export * from "./SponsorAdmin.vue?vue&type=script&lang=js"
import style0 from "./SponsorAdmin.vue?vue&type=style&index=0&id=130338e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130338e6",
  null
  
)

export default component.exports